import 'antd/dist/antd.css';
import moment from 'moment';
import { DatePicker } from 'antd';
import { useState, useEffect } from 'react';
import num2month from '../data_processor/num2month_convertor';

const MonthSelector = (props) => {
    
    const [selectedYear, setSelectedYear] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(1);

    let available_dict = {};
    if(props.streamReady){
        if(props.view === 1 || props.view === 2){
                available_dict = {'0': props.availableYear.uniqueDateMonthProvince,
                '1': props.availableYear.uniqueDateMonthWhole,
                '2': props.availableYear.uniqueDateWeekProvince,
                '3': props.availableYear.uniqueDateWeekWhole,
                '4': props.availableYear.uniqueDateYearProvince,
                '5': props.availableYear.uniqueDateYearWhole
            };
        } else if(props.view === 3){
            available_dict = {'0': props.availableYear.uniqueDateMonthGenderAge,
            };
        }  else if(props.view === 4){
            available_dict = {'0': props.availableYear.uniqueDateMonthProvince,
            };
        }
    } 

    useEffect(() => {
        if(props.view === 1 || props.view === 2){
            setSelectedYear(props.availableYear.uniqueDateWeekProvince[0]);
        } else if(props.view === 3){
            setSelectedYear(props.availableYear.uniqueDateWeekGenderAge[0]);
        } else if(props.view === 4){
            setSelectedYear(props.availableYear.uniqueDateMonthProvince[0]);
        }
        
    }, []);

    const getUnionYear = () => {
        let i = 0;
        let year_union = [];
        if(props.streamReady){
            if(props.view === 1 || props.view === 2){
                for(i=0; i < 6; i++){
                    year_union = [...new Set([...year_union, ...available_dict[i]])];
                }
            } else if(props.view === 3){
                for(i=0; i < 1; i++){
                    year_union = [...new Set([...year_union, ...available_dict[i]])];
                }
            } else if(props.view === 4){
                for(i=0; i < 1; i++){
                    year_union = [...new Set([...year_union, ...available_dict[i]])];
                }
            }
        } else {
            if(props.view === 1 || props.view === 2){
                for(i=0; i < 2; i++){
                    year_union = [...new Set([...year_union, ...available_dict[i]])];
                }
            } else if(props.view === 3){
                year_union = [...new Set([...year_union, ...available_dict[0]])];
            } else if(props.view === 4){
                year_union = [...new Set([...year_union, ...available_dict[0]])];
            }
        }


        year_union.sort(function(a, b) {
        return a - b;
        });
        return year_union;
    }

    const all_available_year = getUnionYear(props.availableYear);
    const startDate = moment(`${all_available_year[0]}-01`);

    function disabledDate(current) {
        const yearStart = moment(`${all_available_year[0]}-01`);
        const yearEnd = moment(`${all_available_year[all_available_year.length - 1]+1}-1`);
        return !(yearStart.isSameOrBefore(current) && yearEnd.isAfter(current));
    }

    function onChange(date, dateString) {
        if (date === null){
            setSelectedYear(selectedYear);
            setSelectedMonth(selectedMonth);
        } else {
            setSelectedYear(date.year());
            setSelectedMonth(date.month()+1);
        }
      }
    
    props.onChange(selectedYear,selectedMonth);

      return (   
        <div>
            <DatePicker allowClear={false} 
            style={{ width: 154, color: '#70ad47', fontFamily: 'Helvetica', fontSize: '15px' }}
            onChange={onChange} 
            picker="month"
            disabledDate={disabledDate}
            defaultValue={startDate} />
        </div> 
        
      );
}
 
export default MonthSelector;